// src/components/topBar/index.js
import React from "react";
import styled from "styled-components";
import MainAppBar from "./appBar";
import Logo from "./logo";
import Navigation from "./navigation";
import UserMenu from "./userMenu";

const TopBar = ({ isSignedIn, setIsSignedIn }) => {
  if (!isSignedIn) return null;

  return (
    <MainAppBar>
      <Container>
        <Logo />
        <Navigation />
      </Container>

      <Container>
        <UserMenu setIsSignedIn={setIsSignedIn} />
      </Container>
    </MainAppBar>
  );
};

export default TopBar;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
